// AppContent.js
import axios from "axios";
import React, { useState, useEffect } from 'react';
import { useMediaQuery } from "@mui/material";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { logDev } from "../src/utils/logger.js";
import LandingPage from "./pages/LandingPage.js"

import { useTheme } from "./context/ThemeContext";

import Snow from "./effects/SnowEffect.js";
import Halloween from "./effects/HalloweenEffect.js";
import Spring from "./effects/SpringEffect.js";
import NewYear from "./effects/NewYearEffect.js";


import PageCGU from "./pages/PageCGU.js";

// Import des composants/pages
import ConnexionGroupe from './components/ConnexionGroup.js';
import Header from './components/Header.js';
import Footer from './components/Footer.js';
import ButtonGrid from './components/ButtonGrid.js';
import FormulaireGroupe from './components/FormulaireGroupe.js';
import TableauListeItems from './components/ListItems/TableauListeItems.js';
import NoticePopup from './components/NoticePopup.js';
import BottomNav from './components/BottomNav.js';
import MainMenu from './components/MainMenu.js';
import ResetPasswords from "./components/ResetPasswords.js";
import ChoixGroup from './components/ChoixGroup.js';

//import Login from "./pages/Login";
import Survey from "./pages/Survey.js";
import Accueil from "./pages/Accueil.js";
import Compta from "./pages/Compta.js";
import Menus from "./pages/Menus.js";
import Infos from "./pages/Infos.js";
import Liste from "./pages/Liste.js";
import PaiementRouter from "./pages/PaiementRouter.js";
import PagePaiement from "./pages/PagePaiement.js";
import Contacts from './pages/Contacts.js';
import SuccesPaiement from "./pages/SuccesPaiement.js";
import AdminDashboard from "./pages/AdminDashboard.js";
import AdminLogin from "./pages/AdminLogin.js"
import AnnulePaiement from "./pages/AnnulePaiement.js";
import { useGroupe } from "./context/GroupeContext.js"

const AppContent = () => {
  const navigate = useNavigate();

  const { theme } = useTheme();
  console.log("THEME ACTUEL =", theme);

  // Hauteur dynamique du header (utile pour positionner le contenu en dessous)
  const [headerHeight, setHeaderHeight] = useState(0);
  const [footerHeight, setFooterHeight] = useState(0);

  // Groupe actuellement sélectionné
  const [showNotice, setShowNotice] = useState(false);
  
  // Récupération de la route courante
  const location = useLocation();

  // Liste des routes où le BottomNav doit apparaître
  const bottomNavRoutes = ["/survey", "/compta", "/contacts", "/liste", "/menus", "/infos", "/paiement"];
  
  // Liste des routes où le MainMenu doit apparaître
  //const mainMenuRoutes = [ "/",  "/connexion", "/creation",  "/choixgroup"];
  const mainMenuRoutes = [ "/connexion", "/creation",  "/choixgroup"];
  
  // Hauteur du BottomNav (utile pour éviter que le contenu soit masqué)
  const showBottomNav = bottomNavRoutes.some(route =>
  location.pathname.includes(route)
);
  logDev("[AppContent] route active", location.pathname);

  const showMainMenu = mainMenuRoutes.includes(location.pathname);
  const [bottomNavHeight, setBottomNavHeight] = useState(0);
  
  // Nombre de contacts et rôle admin (remontés depuis la page Contacts)
  const [contactsCount, setContactsCount] = useState(0);
  const [isAdmin, setIsAdmin] = useState(false);

  const { groupeId, isReady  } = useGroupe();
  const isMobile = useMediaQuery("(max-width:600px)");
  const isContactsRoute = location.pathname.startsWith("/contacts/");
  const isPaiementRoute = location.pathname.startsWith("/paiement");
  const publicRoutes = [
    "/", 
    "/app",
    "/connexion", 
    "/creation", 
    "/reset-passwords", 
    "/cgu", 
    "/infos", 
    "/admin-login", 
    "/admin"
  ];


  // 🔄 Calcul dynamique de la hauteur du header (utile si responsive)
  /*useEffect(() => {
    const header = document.querySelector('.header');
    if (header) {
      const updateHeight = () => setHeaderHeight(header.offsetHeight);
      updateHeight();
      window.addEventListener('resize', updateHeight);
      return () => window.removeEventListener('resize', updateHeight);
    }
  }, []);*/

  useEffect(() => {
    const header = document.querySelector('.header');
    if (!header) return;

    const observer = new ResizeObserver(() => {
      setHeaderHeight(header.offsetHeight);
    });

    observer.observe(header);
    Array.from(header.children).forEach(child => observer.observe(child));

    return () => observer.disconnect();
  }, []);

  // Nettoyer le localStorage si le groupe est supprimé
    useEffect(() => {
      const id = localStorage.getItem("groupeId") || sessionStorage.getItem("groupeId");

      if (id) {
        axios.get(`${process.env.REACT_APP_API}/groupes/${id}`)
          .catch(() => {
            localStorage.removeItem("groupeId");
            sessionStorage.removeItem("groupeId");
            navigate("/connexion");
        });
      }
    }, [navigate]);

    if (!isReady) return null;
  
     if (!groupeId && 
      !isContactsRoute &&
      !isPaiementRoute &&
      !publicRoutes.includes(location.pathname)
) {
  return <Navigate to="/connexion" replace />;
}

    logDev("[AppContent] layout debug", {
      pathname: location.pathname,
      isMobile,
      showBottomNav,
      showMainMenu,
      headerHeight,
      footerHeight,
      bottomNavHeight,
      groupeId,
      isReady
    });

  return (
    <div className="background-wrapper">


      <Header onHeightChange={setHeaderHeight} />
      
      {/* Contenu principal, décalé sous le header */}
      <div className="content-container" 
        style={{ 
          /*paddingTop: `${headerHeight + 16}px`, */ // ✅ avec dégagement visuel
          paddingTop: isMobile 
            ? `${headerHeight + 16}px` 
            : `${headerHeight + bottomNavHeight + 16}px`,
          paddingBottom: `${bottomNavHeight}px`,
          boxSizing: "border-box"
        }}
        >
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/app" element={<Accueil  groupeId={groupeId} />} />
          <Route path="/ChoixGroup" element={<ChoixGroup groupeId={groupeId}/>} />
          <Route path="/connexion" element={<ConnexionGroupe />} />
          <Route path="/creation" element={<FormulaireGroupe />} />
          <Route path="/reset-passwords" element={<ResetPasswords />} />
          <Route path="/contacts" element={
            <Contacts 
            headerHeight={headerHeight} 
            groupeId={groupeId} 
            onContactsChange={(contacts, admin) => {
              setContactsCount(contacts.length);
              setIsAdmin(admin);
            }}
          />
          } />

          <Route path="/contacts/:groupeId"  element={
            <Contacts
              headerHeight={headerHeight}
              onContactsChange={(contacts, admin) => {
                setContactsCount(contacts.length);
                setIsAdmin(admin);
              }}
            />
          } />
          <Route
            path="/dashboard"
            element={
              groupeId
                ? <ButtonGrid headerHeight={headerHeight} groupeId={groupeId} />
                : <Navigate to="/connexion" replace />
            }
          />
          <Route path="/survey" element={<Survey bottomNavHeight={bottomNavHeight} groupeId={groupeId} />} />
          <Route path="*" element={<Accueil headerHeight={headerHeight} groupeId={groupeId} />} />       
          <Route path="/compta" element={<Compta groupeId={groupeId} />} />
          <Route path="/menus" element={<Menus groupeId={groupeId} />} />
          <Route path="/infos" element={<Infos groupeId={groupeId} />} />
         <Route path="/liste" element={<Liste groupeId={groupeId} />} /> 
          {/*<Route path="/liste/:groupeId" element={<Liste />} /> */}     
          {/*<Route path="/tableaulisteitems" element={<TableauListeItems headerHeight={headerHeight} groupeId={groupeId} />} />*/}
          <Route path="/paiement" element={<PagePaiement />} />
          <Route path="/paiement/:groupeId" element={<PaiementRouter headerHeight={headerHeight} />} />
          <Route path="/succes/:groupeId" element={<SuccesPaiement />} />
          <Route path="/annule/:groupeId" element={<AnnulePaiement />} />
          <Route path="/admin" element={<AdminDashboard email="ton@email.com" />} />    
          <Route path="/cgu" element={<PageCGU />} />   
          <Route path="/admin-login" element={<AdminLogin onLogin={() => navigate("/admin")} />} />
    </Routes>
  </div>

  {/* Footer global */}
  {/*<Footer onHeightChange={setFooterHeight} headerHeight={headerHeight}/>   */}
    <Footer
      onHeightChange={setFooterHeight}
      headerHeight={headerHeight}
      isMobile={isMobile}
    />
    
    {/* Popup de bienvenue */}
    {showNotice && <NoticePopup onClose={() => setShowNotice(false)} />}
          
    {/* Barre de navigation du bas (visible seulement sur certaines routes) */}
    {showBottomNav && (
      <BottomNav
        isMobile={isMobile}
        headerHeight={headerHeight}
        onHeightChange={setBottomNavHeight} // ✅ récupère la hauteur
        onNoticeClick={() => setShowNotice(true)} // ouvre la popup
        isAdmin={isAdmin}              // ✅ on passe la valeur
        contactsCount={contactsCount}  // ✅ on passe la valeur
      />
    )}
    
    {/* Barre de navigation d’entrée (Accueil / Connexion / Création) */}
    {showMainMenu && (
      <MainMenu
        isMobile={isMobile}
        headerHeight={headerHeight}
      />
    )}      
    </div>
  );
};

export default AppContent;
